module.exports = __webpack_public_path__ + "assets/img/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/logo.svg
// module id = 1983
// module chunks = 0